import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Link, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import LandingHeader from '../Shared/LandingHeader';
import './LoginPage.css';

const LoginPage = () => {
    const { t, i18n } = useTranslation(['auth', 'common', 'navigation']);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    // Removed local toggleMobileMenu as LandingHeader handles Nav

    const [message, setMessage] = useState({ type: '', text: '' });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: 'info', text: t('auth:login.loggingIn', 'Logging in...') });


        try {
            const response = await fetch(`${API_BASE_URL}login.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(formData)
            });
            const result = await response.json();

            if (result.status === 'success') {
                setMessage({ type: 'success', text: result.message });
                // Persist the full user profile for use throughout the app
                const u = result.user;
                localStorage.setItem('userId', String(u.id));
                localStorage.setItem('studentName', u.fullName);
                localStorage.setItem('boardId', u.boardId ? String(u.boardId) : '');
                localStorage.setItem('classId', u.classId ? String(u.classId) : '');
                localStorage.setItem('studentClass', u.studentClass || '');
                localStorage.setItem('stream', u.stream || '');
                // Also store full user object so components can read all fields
                localStorage.setItem('user', JSON.stringify({
                    id: u.id,
                    name: u.fullName,
                    email: u.email || '',
                    role: u.role || 'free',
                    class_name: u.studentClass || '',
                    userId: u.id,
                    profile_language: u.profile_language || 'en'
                }));
                if (u.profile_language) {
                    i18n.changeLanguage(u.profile_language);
                    localStorage.setItem('i18nextLng', u.profile_language);
                }

                setTimeout(() => {
                    navigate('/dashboard');
                }, 1500);
            } else {
                setMessage({ type: 'error', text: result.message });
            }
        } catch (error) {
            setMessage({ type: 'error', text: t('auth:login.connectionError', 'Connection error. Please ensure PHP server is running.') });
        }

    };

    return (
        <div className="login-page">
            <LandingHeader activePage="login" />


            <main className="container login-main">
                <div className="login-container">
                    <div className="login-hero">
                        <div className="hero-content">
                            <h1 className="hero-title">{t('auth:login.titlePrefix', 'Welcome')} <span className="gradient-text">{t('auth:login.titleSuffix', 'Back!')}</span></h1>
                            <p className="hero-subtext">{t('auth:login.subtitle', 'Login to continue your personalized AI learning journey and track your academic progress.')}</p>
                        </div>
                        <div className="hero-visual">
                            <div className="floating-elements-fallback">
                                <span className="float-icon">🔓</span>
                                <span className="float-icon">📊</span>
                                <span className="float-icon">✨</span>
                            </div>
                        </div>
                    </div>

                    <div className="login-form-section">
                        {message.text && (
                            <div className={`auth-message ${message.type}`}>
                                {message.text}
                            </div>
                        )}
                        <form className="login-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>{t('auth:login.emailPhone', 'Email / Phone')}</label>
                                <input type="text" name="email" placeholder={t('auth:login.emailPhonePlaceholder', 'Enter your email or phone number')} onChange={handleChange} required />
                            </div>

                            <div className="form-group">
                                <div className="label-row">
                                    <label>{t('auth:login.password', 'Password')}</label>
                                    <Link to="/forgot-password" style={{ fontSize: '0.85rem', color: '#00d4ff' }}>{t('auth:login.forgotPassword', 'Forgot Password?')}</Link>
                                </div>
                                <input type="password" name="password" placeholder={t('auth:login.passwordPlaceholder', 'Enter your password')} onChange={handleChange} required />
                            </div>

                            <button type="submit" className="btn btn-primary full-width">{t('auth:login.submit', 'Login')}</button>

                        </form>

                        {/* <div className="social-login">
                            <p>Or login with</p>
                            <div className="social-buttons">
                                <button className="social-btn google"><span className="social-icon">G</span> Google</button>
                                <button className="social-btn apple"><span className="social-icon">🍎</span> Apple</button>
                                <button className="social-btn facebook"><span className="social-icon">f</span> Facebook</button>
                            </div>
                        </div> */}

                        <footer>
                            <p>{t('auth:login.noAccount', "Don't have an account?")} <Link to="/register">{t('auth:login.signUp', 'Sign Up')}</Link></p>
                            {/* <div className="footer-socials">
                                <span className="glow-icon">🐦</span>
                                <span className="glow-icon">📸</span>
                                <span className="glow-icon">🔗</span>
                            </div> */}
                        </footer>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default LoginPage;
